import React from 'react';
import { Database, Cloud, Server, Smartphone, Laptop, Wifi } from 'lucide-react';

interface SolutionsProps {
  isDarkMode?: boolean;
}

const Solutions: React.FC<SolutionsProps> = ({ isDarkMode = false }) => {
  const solutions = [
    {
      icon: Database,
      title: "Data Protection",
      description: "Advanced encryption, data loss prevention, and backup solutions to safeguard critical business information."
    },
    {
      icon: Cloud,
      title: "Cloud Security",
      description: "Secure cloud migration, multi-cloud management, and cloud-native security controls."
    },
    {
      icon: Server,
      title: "Network Security",
      description: "Firewall management, intrusion detection, and network segmentation for robust perimeter defense."
    },
    {
      icon: Smartphone,
      title: "Mobile Security",
      description: "Mobile device management, app security, and BYOD policy implementation."
    },
    {
      icon: Laptop,
      title: "Endpoint Protection",
      description: "Advanced endpoint detection and response (EDR) with AI-powered threat hunting."
    },
    {
      icon: Wifi,
      title: "IoT Security",
      description: "Secure IoT device management, network isolation, and industrial control system protection."
    }
  ];

  return (
    <section id="solutions" className={`py-20 ${isDarkMode ? 'bg-slate-900' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${
            isDarkMode ? 'text-slate-100' : 'text-slate-900'
          }`}>
            Industry-Leading Solutions
          </h2>
          <p className={`text-xl max-w-3xl mx-auto ${
            isDarkMode ? 'text-slate-300' : 'text-slate-600'
          }`}>
            Cutting-edge cybersecurity technologies and methodologies designed 
            to protect modern digital infrastructure and business operations.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div key={index} className={`p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow ${
              isDarkMode 
                ? 'bg-slate-800 border border-slate-700 hover:bg-slate-750' 
                : 'bg-slate-50 border border-slate-200 hover:bg-white'
            }`}>
              <solution.icon className={`h-12 w-12 mb-4 ${
                isDarkMode ? 'text-blue-400' : 'text-blue-600'
              }`} />
              <h3 className={`text-xl font-semibold mb-3 ${
                isDarkMode ? 'text-slate-100' : 'text-slate-900'
              }`}>{solution.title}</h3>
              <p className={isDarkMode ? 'text-slate-300' : 'text-slate-600'}>{solution.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;